import { Loader, isObject } from 'kiswe-ui'
import { LOCAL_DEV_HOST } from '@/env'
import LinkPointerBase, { PointerTypes } from '../LinkPointerBase'

export default class EventLinkPointer extends LinkPointerBase {
  pointerType: PointerTypes.EVENT = PointerTypes.EVENT
  castId: string = ''
  token: string = ''

  constructor (data: unknown) {
    super(data)
    if (!data || !isObject(data)) return
    this.castId = Loader.loadString(data, 'castId', this.castId)
    this.token = Loader.loadString(data, 'token', this.token)

    if ('eventId' in data && !('castId' in data)) {
      this.castId = Loader.loadString(data, 'eventId', this.castId)
    }
  }

  get targetUrl (): string {
    const path = `/event/${ this.castId }?token=${ this.token }`
    if (location.hostname === LOCAL_DEV_HOST) {
      return window.location.origin + path
    } else {
      const version = window.location.pathname.split('/')[1] // pathname = /3.11.0/assets/...
      return window.location.origin + `/${version}${path}`
    }
  }

  get suffix (): string {
    return this.urlSuffix
  }

  /** @deprecated: use castId */
  get eventId () {
    return this.castId
  }

  /** @deprecated: use castId */
  set eventId (newVal: string) {
    this.castId = newVal
  }
}
